import axios from "axios";

const DEFAULT_BACKEND_URL = "http://localhost:8002";

export function getBackendUrl() {
    const raw = process.env.REACT_APP_BACKEND_URL?.trim();
    return raw ? raw.replace(/\/+$/, "") : DEFAULT_BACKEND_URL;
}

export function backendUrl(path = "") {
    const base = getBackendUrl();
    if (!path) return base;
    return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}

export const API_BASE = backendUrl("/api");

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
    if (detail == null) {
        return `Unable to reach the backend. Expected the API at ${API_BASE}.`;
    }
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
